<nz-form-control [nzErrorTip]="errorMessage | translate:translationData"
	[class.large-form]="isWizard" class="text-input">
	<nz-textarea-count [nzMaxCharacterCount]="maxLength">
		<textarea nz-input
			[(ngModel)]="selected"
			[name]="question.type"
			(ngModelChange)="onTextChange()"
			[disabled]="finishedAndLocked || isLocked"
			[nzAutosize]="{ minRows: 1, maxRows: isWizard ? 14 : 7 }"
			[required]="!this.question.isAnswerOptional"
			[minlength]="minLength"
			[maxlength]="maxLength"
			(focusin)="disableSwipe()"
			(focusout)="enableSwipe()">
		</textarea>
	</nz-textarea-count>
</nz-form-control>
